var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('v-chip',{attrs:{"color":"grey lighten-2","close":!this.value.isHidden},on:{"click:close":function($event){return _vm.$emit('delete')}}},[_vm._v(" "+_vm._s(_vm.value.label)+": "),_c('strong',[_vm._v(_vm._s(_vm.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }